import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

export default class mailercl extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            email: '',
            message: ''
        } 
    }

    handleEmailChange = (event)=>{
        this.setState({email: event.target.value})
    }
    handleMessageChange =(event)=>{
        this.setState({message: event.target.value})
    }
    sendMail =(event)=>{
        event.preventDefault();
        console.log(this.state)
    }

    render(){

        return(
        <>
            <Form onSubmit={this.sendMail.bind(this)}>
                <Form.Group controlId="formBasicEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control type="email" name="email" value={this.state.email} placeholder="Enter email" onChange={this.handleEmailChange.bind(this)} />
                    <Form.Text className="text-muted">
                    We'll never share your email with anyone else.
                    </Form.Text>
                </Form.Group>
                <Form.Group controlId="exampleForm.ControlTextarea1">
                    <Form.Label>Example textarea</Form.Label>
                    <Form.Control as="textarea" name="message" value={this.state.message} rows="3" onChange={this.handleMessageChange.bind(this)} />
                </Form.Group>
                <Button variant="primary" type="submit">
                    Submit
                </Button>
            </Form>
        </>
        )
    }


    
    
}
